/**
 * Settings UI - Mode toggle and model selection
 */

import { appendMessage } from "../utils/helpers.js";
import { debugError } from "../config/debugConfig.js";

let editMode = true;
let currentModel = "gpt-5.4";
let openAIServiceRef = null;

// Setter for OpenAI service reference (to avoid circular dependency)
export function setOpenAIServiceRef(service) {
  openAIServiceRef = service;
}

// Getters
export function isEditMode() {
  return editMode;
}

export function getCurrentModel() {
  return currentModel;
}

// Mode toggle functions
export function loadMode() {
  const savedMode = localStorage.getItem("editMode");
  if (savedMode !== null) {
    editMode = savedMode === "true";
  }
  
  // Update UI
  const toggle = document.getElementById("mode-toggle");
  const analyseLabel = document.getElementById("analyse-label");
  const editLabel = document.getElementById("edit-label");
  
  if (toggle) toggle.checked = editMode;
  
  if (editMode) {
    if (analyseLabel) analyseLabel.classList.remove("active");
    if (editLabel) editLabel.classList.add("active");
  } else {
    if (analyseLabel) analyseLabel.classList.add("active");
    if (editLabel) editLabel.classList.remove("active");
  }
}

export function toggleMode(event) {
  editMode = event.target.checked;
  localStorage.setItem("editMode", editMode.toString());
  
  // Update label styles
  const analyseLabel = document.getElementById("analyse-label");
  const editLabel = document.getElementById("edit-label");
  
  if (editMode) {
    if (analyseLabel) analyseLabel.classList.remove("active");
    if (editLabel) editLabel.classList.add("active");
    appendMessage("🔧 Bearbeitungsmodus aktiviert - Daten werden angepasst.", false);
  } else {
    if (analyseLabel) analyseLabel.classList.add("active");
    if (editLabel) editLabel.classList.remove("active");
    appendMessage("🔍 Analysemodus aktiviert - Daten werden nur analysiert, nicht bearbeitet.", false);
  }
}

// Model selection functions
export function loadModel() {
  const savedModel = localStorage.getItem("selectedModel");
  if (savedModel) {
    currentModel = savedModel;
  }
  
  // Update UI
  const modelSelect = document.getElementById("model-select");
  if (modelSelect) {
    modelSelect.value = currentModel;
  }
  
  // Update OpenAI service if it exists
  if (openAIServiceRef) {
    openAIServiceRef.deploymentName = currentModel;
  }
}

export function changeModel(event) {
  currentModel = event.target.value;
  localStorage.setItem("selectedModel", currentModel);
  
  // Update OpenAI service deployment name
  if (openAIServiceRef) {
    openAIServiceRef.deploymentName = currentModel;
  }
  
  // Show confirmation message with model name
  const modelNames = {
    "gpt-5-chat": "GPT-5",
    "gpt-5.1-chat": "GPT-5.1",
    "gpt-5.4": "GPT-5.4",
    "gpt-5-mini": "GPT-5 Mini",
    // "claude-sonnet-4-5": "Sonnet 4.5",
    "Llama-4-Scout": "Llama-4 Scout",
    "model-router": "Auto"
  };
  
  const modelName = modelNames[currentModel] || currentModel;
  appendMessage(`🤖 Modell gewechselt zu: ${modelName}`, false);
}

// Version display
export function updateVersionDisplay() {
  const version = typeof APP_VERSION !== 'undefined' ? APP_VERSION : '0.0.0';
  const versionElement = document.getElementById("app-version");
  if (versionElement) {
    versionElement.textContent = `v${version}`;
  }
}

export async function clearAddinCache(appendMessageFn) {
  try {
    const versionElement = document.getElementById("app-version");
    const originalText = versionElement.textContent;
    versionElement.textContent = "Reloading...";
    versionElement.style.color = "#E6003C";
        
    sessionStorage.clear();
   
    // Clear browser cache for the add-in
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => {
          caches.delete(name);
        });
      });
    }
    
    setTimeout(() => {
      versionElement.textContent = originalText;
      versionElement.style.color = "grey";
      
      try {
        // Force hard reload (bypasses cache)
        window.location.reload(true);
      } catch (reloadError) {
        debugError("Error reloading add-in:", reloadError);
        appendMessageFn("ℹ️ Bitte laden Sie das Add-in manuell neu (Strg+Shift+R für Hard Reload).", false);
      }
    }, 500);
    
  } catch (error) {
    debugError("Error clearing cache:", error);
    appendMessageFn("❌ Fehler beim Leeren des Caches.", false);
  }
}

export function openHelpEmail(currentUserEmail) {
  const versionText = document.getElementById("app-version")?.textContent || 'unknown';
  const subject = encodeURIComponent("Hilfeanfrage - LEA - Logical Engineering Assistant");
  const body = encodeURIComponent(`Hallo Support-Team,

Ich benötige Hilfe mit LEA.

Bitte beschreiben Sie hier Ihr Problem oder Ihre Frage:

---

LEA Version: ${versionText}
Benutzer: ${currentUserEmail || "Nicht angemeldet"}

Vielen Dank für Ihre Unterstützung!

Mit freundlichen Grüßen`);
  
  const mailtoUrl = `mailto:support@caeexpert.group?subject=${subject}&body=${body}`;
  window.location.href = mailtoUrl;
}